<template>
  <v-dialog v-model="showDialog" width="900">
    <v-card class="pa-3">
      <v-card-title class="headline" primary-title>
        Add
        {{
          $route.name.includes('training.resources')
            ? 'Student Leader Training Resource'
            : 'Lunchtime Group Resource'
        }}
      </v-card-title>
      <v-card-text>
        <resource-form ref="form" tag v-model="resource" />
        <v-btn
          :loading="loading"
          :disabled="loading"
          color="primary"
          @click="submit"
          >Save</v-btn
        >
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Resource from '@/models/Resource'
import ResourceForm from '@/components/resource/Form'
import { each } from 'lodash'
import * as ResourceType from '@/utils/consts/ResourceType'

export default {
  name: 'CreateResources',

  components: {
    ResourceForm
  },

  data() {
    return {
      loading: false,
      showDialog: true,
      resource: new Resource({
        title: '',
        subtitle: ''
      })
    }
  },

  methods: {
    onClose() {
      this.$router.push({ name: 'resources' })
    },

    submit() {
      this.loading = true
      const form = new FormData()
      form.append(
        'type',
        this.$route.name.includes('training.resources')
          ? ResourceType.TRAINING
          : ResourceType.LTG
      )
      each(this.resource, (value, key) => {
        if (value) {
          form.append(key, value)
        }
      })

      this.$api
        .post('/resources', form)
        .then(({ data }) => {
          this.$toast('Lunchtime group resource successfully saved!', {
            color: 'green'
          })
          this.$router.replace({
            name: this.$route.name.includes('training.resources')
              ? 'training.resources.edit'
              : 'resources.edit',
            params: { id: data.data.id }
          })
        })
        .catch(({ response }) => {
          if (response.data && response.data.errors) {
            this.$refs.form.setErrors(response.data.errors)
          }
        })
        .then(() => {
          this.loading = false
        })
    }
  },
  watch: {
    showDialog(show) {
      if (!show) {
        this.onClose()
      }
    }
  }
}
</script>
